import { flightApi } from "@/api/flightApi";
import { FlightSearchResult } from "@/core/types/types";
import { useEffect, useState } from "react";
import { splitDateFromISOString } from "@/core/utils";

interface UseFlightResultsInput {
  departureDate: string;
  originAirport?: string;
  destinationAirport?: string;
}

const useFlightResults = ({
  departureDate,
  originAirport,
  destinationAirport,
}: UseFlightResultsInput) => {
  const [selectedFlightDate, setSelectedFlightDate] = useState<string | null>(
    null
  );

  const [selectedFlight, setSelectedFlight] = useState<
    FlightSearchResult | null | undefined
  >(undefined);

  const [flightResults, setFlightResults] = useState<FlightSearchResult[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const formattedDate = splitDateFromISOString(departureDate);
    setSelectedFlightDate(formattedDate);
  }, [departureDate]);

  // Query flights when the user's  information is ready
  // re-query if the user selects a new date
  useEffect(() => {
    const searchFlights = async () => {
      if (!selectedFlightDate || !originAirport || !destinationAirport) {
        setIsLoading(false);
        return;
      }
      setIsLoading(true);

      let results;
      try {
        results = await flightApi.searchFlights({
          departureDate: selectedFlightDate,
          originAirport: originAirport,
          destinationAirport: destinationAirport,
        });
      } catch (error: any) {
        console.error(
          `Error occurred while fetching flights for route: [${originAirport}] - [${destinationAirport}], at [${selectedFlightDate}] \n${error}`
        );
        results = [];
      }

      setFlightResults(results);
      setIsLoading(false);
    };

    searchFlights();
  }, [selectedFlightDate, originAirport, destinationAirport]);

  return {
    selectedFlightDate,
    selectedFlight,
    flightResults,
    setSelectedFlightDate,
    setSelectedFlight,
    // TODO: use react-swr
    hasError: !selectedFlightDate || !flightResults,
    isLoading,
  };
};

export { useFlightResults };
